/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import '@maru/hub-vuetify-components/style' // imports Maru style rules
import './styles/settings.scss' //imports global styles for this project only
import { createApp } from '@maru/vuetify-theme'
import MDraggable from "@maru/hub-vuetify-components/m-draggable";
import App from './App.vue'

// Plugins
import { registerPlugins, registerComponents } from '@/plugins'
import { loadRuntimeConfig } from '@/constants/runtimeConfig'
import { loadVerisoulScript } from '@/constants/verisoul'

const bootstrap = async () => {
  await loadRuntimeConfig();
  loadVerisoulScript();

  const app = createApp(App)

  registerPlugins(app)
  registerComponents(app)
  app.component('MDraggable', MDraggable);

  app.mount('#app')
}

void bootstrap()
